import UploadGroupDataDialog from '@sophocles/components/UploadGroupDataDialog/UploadGroupDataDialog';

export default UploadGroupDataDialog;
